module.exports = __webpack_public_path__ + "img/nbus_box_2-1.d3a02fec.jpg";